// src/lib/menage-avis-api.js — CHANTIER AVIS MÉNAGE/ORCH Lot N1 (CLIENT)
//
// Client LECTURE SEULE de l'endpoint /api/beds24-mapping?action=menage_avis.
// Réservé aux rôles AGENT ('menage') et ORCHESTRATEUR ('orchestrateur') (admin
// accepté). Le SCOPE (logements nettoyés) est résolu CÔTÉ SERVEUR à partir du
// JWT (email agent) ou app_metadata frais (pool orchestrateur) — ce client
// n'envoie JAMAIS de logIds de scope : il peut passer un `logementId` de FILTRE,
// intersecté côté serveur (anti-IDOR). Aucun appel d'écriture (lecture seule).
//
// Auth : Bearer JWT Supabase (même pattern que proprio-api.js / cfg-api.js).
// La vue UI (Lot N2) consommera fetchMenageAvis() — ce lot ne crée AUCUNE vue.

import { supabase } from '../supabase'

const ENDPOINT = '/api/beds24-mapping'

// En-têtes auth (Bearer JWT). Pattern repris de src/lib/proprio-api.js.
async function authHeaders() {
  const { data: { session } } = await supabase.auth.getSession()
  const token = session?.access_token
  return token ? { Authorization: `Bearer ${token}` } : {}
}

// Avis voyageurs des logements du périmètre de l'utilisateur (agent : logements
// qu'il a personnellement nettoyés ; orchestrateur : pool ∩ logIds). Renvoie
// { avis, statsByLog, statsOverall }. `logementId` optionnel = filtre serveur
// (intersecté au scope, jamais d'élargissement). Fail-closed serveur : scope
// vide → { avis: [], statsByLog: {}, statsOverall: { count: 0, avg: null } }.
export async function fetchMenageAvis({ logementId } = {}) {
  const qs = new URLSearchParams({ action: 'menage_avis' })
  if (logementId != null && logementId !== '') qs.set('logement_id', String(logementId))

  let res
  try {
    res = await fetch(`${ENDPOINT}?${qs.toString()}`, {
      method: 'GET',
      headers: await authHeaders(),
    })
  } catch (e) {
    // Erreur réseau — pas de PII dans le message.
    throw new Error('Connexion impossible. Réessayez.')
  }
  const json = await res.json().catch(() => ({}))
  if (!res.ok) {
    throw new Error(json.error || `Erreur ${res.status}`)
  }
  return json
}
